/**
 * Created by Ning Jiang on 2021-06-21.
 */

import {WinPresentationController} from "../WinPresentationController";
import {gsap, TimelineLite} from "gsap";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DeadwoodRipLayers, Layers} from "../../view/DeadwoodRipLayers";
import {DeadwoodRip} from "../../DeadwoodRip";
import {IBetWayWinData} from "../../server/data/IDeadwoodRipData";
import {DeadwoodRipSound} from "../../sound/DeadwoodRipSound";

export class XRipController extends WinPresentationController {

    private _layer:StageLayer;

    constructor() {
        super("XRipControllerController", false);

        this._layer = DeadwoodRipLayers.getLayer(Layers.WIN_PRESENTATIONS)!;
    }

    protected hasWin():boolean {
        return DeadwoodRip.model.parsedGameData.xRip;
    }

    protected async createWinAnimation():Promise<any> {
        DeadwoodRip.playScattersWin = true;
        const tl = new TimelineLite();
        DeadwoodRip.model.parsedGameData.betWins.forEach(w => {
            (<IBetWayWinData>w).reelWinPositions.forEach((reelWin, reelId) => {
                reelWin.forEach((winPosition, symId) => {
                    if(winPosition) {
                        tl.add(this.getSymbolRipAnimation(reelId, symId), 0);
                    }
                });
            });
        });
        tl.add(() => {
            DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.XRIP});
        }, 0);
        await Promise.resolve(tl);
    }

    private getSymbolRipAnimation(reelId:number, symId:number):TimelineLite {
        const tl = new TimelineLite();

        const sym = DeadwoodRip.reels[reelId].getSymbol(symId, false, false);
        tl.add(() => DeadwoodRip.reels[reelId].reelView.addWinSymbol(sym));// no need to have win state in this game?
        tl.add(sym.playXRip());
        tl.add(gsap.to(this, {duration : 0.1}));
        return tl;
    }
}